import { Skill, SkillAPIResponse, SkillsAPIResponse } from '@/types';
import api from './client/axios';

export const getSkillsMap = async (): Promise<Skill[]> => {
  const response = await api.get('/skills');
  return response.data.skills;
};

export const addSkill = async (skill: Skill): Promise<SkillAPIResponse> => {
  const response = await api.post('/skills', skill);
  return response.data;
};
